import { Routes, mapToCanActivate } from '@angular/router';
import { LocationGuard } from '@next/core-lib/relationships';

import { DashboardComponent } from './dashboard/dashboard.component';
import { MyAdvertisementsComponent } from './my-advertisements/my-advertisements.component';
import { OfferConfirmationScreenComponent } from './offer/offer-confirmation/offer-confirmation-screen.component';
import { OfferComponent } from './offer/offer.component';
import { RequestConfirmationScreenComponent } from './request/request-confirmation/request-confirmation-screen.component';
import { RequestComponent } from './request/request.component';

export const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/dashboard',
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'offer',
    component: OfferComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'offer/confirmation',
    component: OfferConfirmationScreenComponent,
  },
  {
    path: 'request',
    component: RequestComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'request/confirmation',
    component: RequestConfirmationScreenComponent,
  },
  {
    path: 'my-advertisements',
    component: MyAdvertisementsComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
];
